module.exports = __webpack_public_path__ + "static/dl1-screen2-3beec59be34cc2d11aea877d366d36ac.png";